module.exports = __webpack_public_path__ + "static/media/scroll-info.969651d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/scroll-info.png
// module id = 373
// module chunks = 0